import HiringHubPage from "./hiringHubPage";
import Portal from "../../../../../platform/pages/business/portal";

const HiringHubPortal = (props: any) => {
  return <Portal TabComponent={HiringHubPage} title={"Hiring"} props={props} />;
};

export default HiringHubPortal;
